import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import axios from '../../helpers/Axios'
import { Doctor } from './types'
const baseUrl = API_BASE_URL

export const getDoctorsData = async (): Promise<object> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctors`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const getDoctorData = async (id?: string): Promise<object> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctor/${id}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const addDoctorData = async (data: Doctor): Promise<object> => {
  return axios({
    method: 'post',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctor`,
    data: data,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const updateDoctorData = async (
  id: string,
  data: Doctor
): Promise<object> => {
  return axios({
    method: 'put',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctor/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const deleteDoctorData = async (id: string): Promise<object> => {
  return axios({
    method: 'delete',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctor/${id}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const activateDoctorData = async (id: string): Promise<object> => {
  return axios({
    method: 'patch',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctor/${id}/activate`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const changeDoctorRoleData = async (
  id: string,
  role: string
): Promise<object> => {
  return axios({
    method: 'patch',
    baseURL: baseUrl,
    url: `/api/rpmweb/doctor/${id}/role`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
    data: {
      isSupervisor: role,
    },
  })
}
